import React from 'react';
import { DepartmentBanner, PreviewHeader } from '@noths/polaris-client-ribbons-design-system';
import getConfig from 'next/config';

import { HiddenPageTitle } from 'src/components/atoms/HiddenPageTitle/HiddenPageTitle';
import { Seo } from 'src/components/atoms/Seo/Seo';
import { Sections } from 'src/components/molecules/Sections/Sections';
import type { NextConfig } from 'src/types/NextConfig';
import type { ContentPageProps } from 'src/types/PageProps';
import type { SerializedUISection } from 'src/types/Section';
import * as styles from './RibbonsPage.styles';

const {
  publicRuntimeConfig: { CLEAR_PREVIEW_API_URL },
} = getConfig() as NextConfig;

const blockHasPageTitle = (blocks: SerializedUISection[]) =>
  blocks.some((block) => block.props.headingIsPageTitle);

export const RibbonsPage = ({
  pageContent: { departmentBanner, sections, seo, title },
  pageMetadata: { isPreview },
}: ContentPageProps) => {
  const renderHiddenPageTitle = !blockHasPageTitle(sections);

  return (
    <div css={styles.container}>
      <Seo {...seo} />
      {departmentBanner && <DepartmentBanner {...departmentBanner} />}
      {renderHiddenPageTitle && <HiddenPageTitle>{title}</HiddenPageTitle>}
      {isPreview && <PreviewHeader href={CLEAR_PREVIEW_API_URL} />}
      {sections ? <Sections isPreview={isPreview} sections={sections} /> : null}
    </div>
  );
};
